import axios from 'axios';

/**
 * Request interceptor
 * @param {*} store
 * @returns
 */
const requestInterceptor = store => async config => {
  const {locale} = store.state.user;
  const {url, method, data, params} = config;

  config.headers['Accept-Language'] = 'en-US';
  // add "locale" param
  // if (method === 'post') {
  //   if (!data?.locale) config.data = data ? {...data, locale} : {locale};
  // } else if (!params?.locale) {
  //   config.params = params ? {...params, locale} : {locale};
  // }


  const {accessToken} = store.state.user;
  if (accessToken) config.headers['Authorization'] = `Bearer ${accessToken}`;
  // config.headers['X-CSRFToken'];

  return config;
};

function createClient(vuexStore) {

  const client = axios.create({
    baseURL: 'https://longevityintime.org/api/v2/',
    timeout: 10 * 1e3,
    headers: {'Content-Type': 'application/json'},
  });

  client.interceptors.request.use(requestInterceptor(vuexStore));

  return client;
}

export {
    createClient,
}